import React from "react";
import "./packageCard.css";
import { FiEdit } from "react-icons/fi";
import { HiDotsVertical } from "react-icons/hi";
import { LuTrash2 } from "react-icons/lu";
import {
  Flex,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
  Select,
  Checkbox,
  Input,
  Icon,
} from "@chakra-ui/react";
import GradientBorder from "components/GradientBorder/GradientBorder";
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { CloseIcon, CheckIcon } from "@chakra-ui/icons";
import { position } from 'stylis';
import { MdCampaign } from 'react-icons/md';


function CustomPriceCard({
  card,
  icon = MdCampaign,
  index,
  setselectedPackages = () => {},
}) {
  const {
    duration,
    estimated_reader,
    is_facebook,
    is_instagram,
    is_youtube,
    name,
    price,
    prnumber,
    uuid = "",
  } = card;

  const { isOpen, onOpen, onClose } = useDisclosure();
  const titleColor = "white";
  const history = useHistory();

  const customCardColor = (index) => {
    if (index % 3 === 0) {
      return "card1";
    } else if (index % 3 === 1) {
      return "card2";
    } else {
      return "card3";
    }
  };
  const histoty = useHistory();
  const sendData = (uuid) => {
    setselectedPackages(uuid);
    
  };

  return (
    <div
      class='card-wrapper'
      style={{
        width: "auto",
        minWidth: "270px",
        maxWidth: "270px",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.1)",
        backdropFilter: "blur(1px)",
        borderRadius: "20px",
        boxShadow:
          "0 10px 12px 3px rgba(0, 0, 0, 0.15), inset 0 0px 3px 1px rgba(255, 255, 255, 0.1)",
      }}
    >
      <div class={`card `}>
        <div
          style={{
            position: "relative",
            display:
              localStorage.getItem("group") === "Publisher" ? "flex" : "none",
            justifyContent: "end",
            width: "100%",
            height: "100%",
            marginTop: "-3rem",
            paddingTop: "1.5rem",
            paddingRight: "1.5rem",
            paddingLeft: "1.5rem",
          }}
        >
          <Menu>
            <MenuButton align='center' mt='.7rem' mr='-2rem'>
              <HiDotsVertical mr='0px' w='20px' h='20px' />
            </MenuButton>

            <MenuList
              border='transparent'
              bg='#0099a2'
              //   bg="transparent"
              boxShadow='0px 4px 4px rgba(0, 0, 0, 0.25)'
              borderRadius='20px'
              minWidth='100px'
            >
              <Flex flexDirection='column'>
                <MenuItem
                  borderRadius='8px'
                  _hover={{
                    bg: "transparent",
                  }}
                  _active={{
                    bg: "transparent",
                  }}
                  _focus={{
                    bg: "transparent",
                  }}
                  mb='10px'
                >
                  <div
                    onClick={() =>
                      history.push(
                        `/${localStorage
                          .getItem("group")
                          .toLowerCase()}/packages/update/?uuid=${uuid}`
                      )
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <FiEdit />
                    <Text fontWeight='500' fontSize='16px' as='span'>
                      Edit
                    </Text>
                  </div>
                  <Modal isOpen={isOpen} onClose={onClose} size='3xl'>
                    <ModalOverlay />
                    <ModalContent
                      p='20px'
                      bg={{
                        base: "rgb(19,21,56)",
                      }}
                    >
                      <ModalHeader>
                        {" "}
                        <Text fontSize='lg' color='#fff' fontWeight='bold'>
                          Packages Create
                        </Text>
                      </ModalHeader>
                      <ModalCloseButton color='#fff' />
                      <ModalBody>
                        {/* Form */}
                        <GradientBorder
                          p='2px'
                          w='100%'
                          me={{
                            base: "none",
                            lg: "30px",
                            xl: "none",
                          }}
                        >
                          <Flex
                            background='transparent'
                            borderRadius='30px'
                            direction='column'
                            p='40px'
                            minW={{
                              base: "unset",
                              md: "430px",
                              xl: "450px",
                            }}
                            w='100%'
                            mx={{ base: "0px" }}
                            bg={{
                              base: "rgb(19,21,56)",
                            }}
                          >
                            <FormControl>
                              <FormLabel
                                color={titleColor}
                                ms='4px'
                                fontSize='sm'
                                fontWeight='normal'
                              >
                                Title
                              </FormLabel>
                              <GradientBorder
                                mb='24px'
                                h='50px'
                                w={{ base: "100%", lg: "100%" }}
                                borderRadius='20px'
                              >
                                <Input
                                  color={titleColor}
                                  bg={{
                                    base: "rgb(19,21,54)",
                                  }}
                                  border='transparent'
                                  borderRadius='20px'
                                  fontSize='sm'
                                  size='lg'
                                  w={{ base: "100%", lg: "100%" }}
                                  maxW='100%'
                                  h='46px'
                                  type='text'
                                  placeholder='Title'
                                />
                              </GradientBorder>
                              <FormLabel
                                color={titleColor}
                                ms='4px'
                                fontSize='sm'
                                fontWeight='normal'
                              >
                                Number
                              </FormLabel>
                              <GradientBorder
                                mb='24px'
                                h='50px'
                                w={{ base: "100%", lg: "100%" }}
                                borderRadius='20px'
                              >
                                <Input
                                  color={titleColor}
                                  bg={{
                                    base: "rgb(19,21,54)",
                                  }}
                                  border='transparent'
                                  borderRadius='20px'
                                  fontSize='sm'
                                  size='lg'
                                  w={{ base: "100%", lg: "100%" }}
                                  maxW='100%'
                                  h='46px'
                                  type='text'
                                  placeholder='Number'
                                />
                              </GradientBorder>
                              <FormLabel
                                color={titleColor}
                                ms='4px'
                                fontSize='sm'
                                fontWeight='normal'
                              >
                                Type
                              </FormLabel>

                              <GradientBorder
                                mb='24px'
                                h='50px'
                                w={{ base: "100%", lg: "100%" }}
                                borderRadius='20px'
                              >
                                <Select
                                  color={titleColor}
                                  bg={{
                                    base: "rgb(19,21,54)",
                                  }}
                                  border='transparent'
                                  borderRadius='20px'
                                  fontSize='sm'
                                  size='lg'
                                  w={{ base: "100%", lg: "100%" }}
                                  maxW='100%'
                                  h='46px'
                                  type='text'
                                  placeholder='Type'
                                  sx={{
                                    option: {
                                      backgroundColor: "rgb(19,21,54)",
                                      color: "white",
                                    },
                                  }}
                                >
                                  <option value='basic_pr'>Basic PR</option>
                                  <option value='pr_with_analytics'>
                                    PR with Analytics
                                  </option>
                                </Select>
                              </GradientBorder>

                              <Flex
                                justify='space-between'
                                align='center'
                                mb='24px'
                                ml='16px'
                              >
                                <Checkbox
                                  color={titleColor}
                                  bg={{
                                    base: "rgb(19,21,54)",
                                  }}
                                  borderRadius='20px'
                                  fontSize='sm'
                                  size='md'
                                  variant='subtle'
                                  colorPalette='blue'
                                  w={{ base: "100%", lg: "100%" }}
                                >
                                  Promotion
                                </Checkbox>

                                <Checkbox
                                  color={titleColor}
                                  bg={{
                                    base: "rgb(19,21,54)",
                                  }}
                                  borderRadius='20px'
                                  fontSize='sm'
                                  size='md'
                                  variant='subtle'
                                  colorPalette='blue'
                                  w={{ base: "100%", lg: "100%" }}
                                >
                                  Real-time data
                                </Checkbox>
                                <Checkbox
                                  color={titleColor}
                                  bg={{
                                    base: "rgb(19,21,54)",
                                  }}
                                  borderRadius='20px'
                                  fontSize='sm'
                                  size='md'
                                  variant='subtle'
                                  colorPalette='blue'
                                  w={{ base: "100%", lg: "100%" }}
                                >
                                  Reporting
                                </Checkbox>
                              </Flex>

                              <FormLabel
                                color={titleColor}
                                ms='4px'
                                fontSize='sm'
                                fontWeight='normal'
                              >
                                Content
                              </FormLabel>

                              <GradientBorder
                                mb='24px'
                                h='50px'
                                w={{ base: "100%", lg: "100%" }}
                                borderRadius='20px'
                              >
                                <Select
                                  color={titleColor}
                                  bg={{
                                    base: "rgb(19,21,54)",
                                  }}
                                  border='transparent'
                                  borderRadius='20px'
                                  fontSize='sm'
                                  size='lg'
                                  w={{ base: "100%", lg: "100%" }}
                                  maxW='100%'
                                  h='46px'
                                  type='text'
                                  placeholder='Content'
                                  sx={{
                                    option: {
                                      backgroundColor: "rgb(19,21,54)",
                                      color: "white",
                                    },
                                  }}
                                >
                                  <option value='Business'>Business</option>
                                  <option value='Arts'>Arts</option>
                                  <option value='Sports'>Sports</option>
                                  <option value='Political'>Political</option>
                                  <option value='ETC'>ETC</option>
                                </Select>
                              </GradientBorder>

                              <Button
                                variant='brand'
                                fontSize='10px'
                                type='submit'
                                w={{ base: "100%", lg: "100%" }}
                                maxW='100%'
                                h='45px'
                                mb='20px'
                                mt='20px'
                              >
                                Submit
                              </Button>
                            </FormControl>
                          </Flex>
                        </GradientBorder>
                      </ModalBody>
                      <ModalFooter>
                        <Button colorScheme='blue' mr={3} onClick={onClose}>
                          Submit
                        </Button>
                      </ModalFooter>
                    </ModalContent>
                  </Modal>
                </MenuItem>
                <MenuItem
                  borderRadius='8px'
                  _hover={{
                    bg: "transparent",
                  }}
                  _active={{
                    bg: "transparent",
                  }}
                  _focus={{
                    bg: "transparent",
                  }}
                  mb='10px'
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <LuTrash2 />{" "}
                    <Text fontWeight='500' fontSize='16px' as='span'>
                      Delete
                    </Text>
                  </div>
                </MenuItem>
              </Flex>
            </MenuList>
          </Menu>
        </div>
        <Flex
          direction='row'
          align='center'
          justify='space-between'
          w='110%'
          mt='-1.5rem'
          pl='3rem'
          pr='1.5rem'
        >
          <Icon
            as={icon}
            color='white'
            w='3rem'
            h='3rem'
            p='.5rem'
            bg='rgba(0,0,0,0.4)'
            borderRadius={10}
            mt={5}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",

              alignItems: "flex-end",
              justifyContent: "flex-end",
              marginTop: ".5rem",
            }}
          >
            <div
              class='offer-price'
              style={{
                fontSize: "1.5rem",
              }}
            >
              {Number(price)}
            </div>
            <div
              style={{
                fontSize: ".7rem",
                textAlign: "start",
                textTransform: "uppercase",
                marginTop: "-1.5rem",
                marginLeft: "-2.5rem",
              }}
            >
              <sup>BDT</sup> / <sub>monthly</sub>
            </div>
          </div>
        </Flex>
        <div
          style={{
            backgroundColor: "rgba(0,0,0,0.3)",
            borderRadius: "0 20px 20px 0",
            width: "70%",
            marginLeft: "-40%",
            padding: ".5rem",
            paddingRight: 0,
            marginTop: ".7rem",
          }}
        >
          <p class='offer-title'>{name}</p>
        </div>
        <div
          style={{
            width: "100%",
            paddingLeft: "2.5rem",
            paddingRight: ".7rem",
          }}
        >
          <hr className='hr' />
          <ul
            style={{
              paddingLeft: "1.2rem",
              fontSize: ".8rem",
            }}
          >
            <li>Number of PR : {prnumber} </li>
            <li>Duration : {duration} </li>
            <li>Est. Readers : {estimated_reader} </li>
            <li
              style={{
                position: "relative",
              }}
            >
              Facebook{" "}
              {is_facebook ? (
                <Icon
                  as={CheckIcon}
                  p={"1px"}
                  fontSize={"1rem"}
                  color={"green.200"}
                  position={"absolute"}
                  right={50}
                  top={1}
                />
              ) : (
                <Icon
                  as={CloseIcon}
                  p={"3px"}
                  color={"red"}
                  position={"absolute"}
                  right={50}
                  top={1}
                  fontSize={"1rem"}
                />
              )}
            </li>
            <li
              style={{
                position: "relative",
              }}
            >
              Instagram{" "}
              {is_instagram ? (
                <Icon
                  as={CheckIcon}
                  p={"1px"}
                  color={"green.200"}
                  position={"absolute"}
                  right={50}
                  fontSize={"1rem"}
                  top={1}
                />
              ) : (
                <Icon
                  as={CloseIcon}
                  p={"3px"}
                  color={"red"}
                  position={"absolute"}
                  right={50}
                  fontSize={"1rem"}
                  top={1}
                />
              )}
            </li>
            <li
              style={{
                position: "relative",
              }}
            >
              Youtube{" "}
              {is_youtube ? (
                <Icon
                  as={CheckIcon}
                  p={"1px"}
                  color={"green.200"}
                  position={"absolute"}
                  right={50}
                  fontSize={"1rem"}
                  top={1}
                />
              ) : (
                <Icon
                  as={CloseIcon}
                  p={"3px"}
                  color={"red"}
                  position={"absolute"}
                  right={50}
                  fontSize={"1rem"}
                  top={1}
                />
              )}
            </li>
          </ul>
        </div>
        <button
          class='buy'
          style={{
            color: "#08BCC6FF",
            marginTop: ".5rem",
            width:'300px',
            scale:'.75',
            marginLeft:'1.7rem',
            
          }}
          onClick={() => {
            sendData(uuid);
          }}
        >
          <span style={{ fontWeight: "bolder" }}>Buy now</span>
        </button>
      </div>
    </div>
  );
}

export default CustomPriceCard;
